import script from "./HelmOpResourcesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelmOpResourcesSection.vue?vue&type=script&setup=true&lang=ts"

import "./HelmOpResourcesSection.vue?vue&type=style&index=0&id=62c64cc3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c64cc3"]])

export default __exports__